import get from 'lodash/get';
import includes from 'lodash/includes';

import { graphQLClient } from '../../graphQLClients';

import { UpdateItemGqlQuery } from '../../../../../types';

import { generateUuid } from '../../../../../utils/generateUuid';
import { getQueryName } from '../../../../../utils/getQueryName';
import { productionConsole } from '../../../../../utils/productionConsole';

import { errorMessageStatusOrErrorsIsIncorrect } from '../../reactQueryConstants';

interface UpdateItemProps<UpdateItemInput> {
  action: string;
  query: UpdateItemGqlQuery;
  queryInput: UpdateItemInput;
}

const successQueryStatuses = ['updated', 'success', 'ok'];

export function updateItem<UpdateItemInput, UpdateItemResponse>({
  action,
  query,
  queryInput
}: UpdateItemProps<UpdateItemInput>) {
  const { rawName, name } = getQueryName(query, 'mutation');

  productionConsole(
    'log',
    'updateItem',
    { action, queryInput },
    rawName,
    JSON.stringify(queryInput)
  );

  const requestId = generateUuid();

  graphQLClient.addQueryParams(name, requestId);

  return new Promise<UpdateItemResponse>((resolve, reject) => {
    graphQLClient
      .request<UpdateItemResponse, UpdateItemInput>(query, queryInput, {
        requestId
      })
      .then((response) => {
        if (includes(successQueryStatuses, get(response, `${action}.status`))) {
          return resolve(response);
        }

        const errors = get(response, `${action}.errors`);

        reject(errors ? errors : errorMessageStatusOrErrorsIsIncorrect);
      })
      .catch((reason) => reject(reason));
  });
}
